import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

type Props = {
	isSpoiler: boolean
}

export const ButtonText = styled(ButtonPlain)<Props>`
	height: 30px;
	min-height: unset;
	color: ${({ isSpoiler, theme }) => (isSpoiler ? 'transparent' : theme.color.text)};
	text-shadow: ${({ isSpoiler }) => (isSpoiler ? '0 0 8px rgba(0, 0, 0, 0.5)' : 'none')};
	transition:
		color 0.15s ease-in-out,
		text-shadow 0.1s ease-in-out;
`
